var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"base-chip",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass],
    [{
      'body-2 py-3': !_vm.props.small,
      'body-1 py-1': _vm.props.small,
    }] ),style:((Array.isArray(_vm.data.style) ? _vm.data.style : [_vm.data.style]).concat( [_vm.data.staticStyle]))},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }